import { parseISO } from "date-fns";
import AttachmentDomain from "entities/domain/attachments/attachment-domain";
import MessageDomain, {
  MessageButton,
  MessageButtonType,
  MessageDirection,
  MessageReaction,
  MessageStatus,
  MessageSubType,
  MessageType,
} from "entities/domain/conversations/message-domain";
import {
  MessageButtonDTO,
  MessageDTO,
  MessageReactionDTO,
} from "entities/dto/ConversationDTO";
import { flattenObject } from "util/methods";
import { attachmentTransformFromDtoToDomain } from "./attachmentTransformer";

export const messageButtonTransformFromDtoToDomain = (
  b: MessageButtonDTO
): any => {
  return new MessageButton(
    b.type as MessageButtonType,
    b.text,
    b.url,
    b.phone_number
  );
};

function withUtcSuffix(timestamp: string): string {
  return timestamp.includes("Z") ? timestamp : `${timestamp}Z`;
}

export function messageReactionTransformFromDtoToDomain(
  r: MessageReactionDTO
): MessageReaction {
  return {
    emoji: r.emoji,
    reactorHandle: r.reactor_handle,
    reactorName: r.reactor_name,
    reactedAt: parseISO(withUtcSuffix(r.reacted_at)),
  };
}

export const messageTransformFromDtoToDomain = (m: MessageDTO): MessageDomain =>
  new MessageDomain(
    m.id,
    m.body,
    m.is_incoming,
    parseISO(m.created_at.includes("Z") ? m.created_at : `${m.created_at}Z`),
    m.conversation_id,
    m.agent_id,
    m.status ? (m.status as MessageStatus) : MessageStatus.UNKNOWN,
    m.type ? (m.type as MessageType) : MessageType.TEXT,
    m.sub_type as MessageSubType,
    m.title ? m.title : null,
    m.reply_to_message_id ? m.reply_to_message_id : null,
    m.direction as MessageDirection,
    m.metadata
      ? {
          ...m.metadata,
          attributes: m.metadata.attributes
            ? flattenObject(m.metadata.attributes)
            : undefined,
        }
      : null,
    m.attachments
      ? m.attachments.map((ato) => attachmentTransformFromDtoToDomain(ato))
      : ([] as AttachmentDomain[]),
    m.raw_html ? m.raw_html : null,
    m.buttons?.map(messageButtonTransformFromDtoToDomain) || null,
    m.ai_assistant_id || undefined,
    m.automation_run_id || undefined,
    m.campaign_id || undefined,
    m.reply_to_message
      ? {
          id: m.reply_to_message.id,
          body: m.reply_to_message.body,
          isIncoming: m.reply_to_message.is_incoming,
          senderName: m.reply_to_message.sender_name,
          attachments: m.reply_to_message.attachments ?? [],
        }
      : null,
    m.can_reply ?? false,
    m.reactions?.map(messageReactionTransformFromDtoToDomain) ?? [],
    m.reactions_revision ?? 0
  );

export const messagesTransformFromDtoToDomain = (
  messages: MessageDTO[]
): MessageDomain[] => messages.map(messageTransformFromDtoToDomain);

export default messagesTransformFromDtoToDomain;
